import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019-2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { EnvUtils } from '@spm/core';

/**
 * Add feature toggles here to centralize control.
 * By convention the feature toggle is controlled by a environment property in the
 * .env/.env.development file, but that can be overridden if required.
 *
 * Feature toggles will fall into 1 or more of these categories
 *  1) feature only works with certain versions of SPM, e.g. APIs don't exist in v7.0.3
 *  2) feature is dependent on SPM component that may not be installed, e.g. Appeals.
 *  3) feature is optional and may be on or off in different deployments based on business requirements.
 *  4) feature is unfinished but code is deployed in production, so needs to be hidden.
 *
 * In general feature toggles should be removed as soon as possible to simplify the branches in code and the configuration permutations, e.g.
 *  - if 1 above, remove when the UA app no longer supports the SPM version that the feature is not available on.
 *  - if 4 above, when the feature is fully available, the code should be removed.
 * Each release should review the features for continued necessity.
 *
 */

// To be deleted in v.6.0.0
// eslint-disable-next-line camelcase
export var UNSAFE_EntitlementCardEnvVarName = function UNSAFE_EntitlementCardEnvVarName() {
  return process.env.REACT_APP_FEATURE_PAYMENT_DETAILS_ENABLED !== undefined ? 'REACT_APP_FEATURE_PAYMENT_DETAILS_ENABLED' : 'REACT_APP_ENTITLEMENT_CARD_ENABLED';
};
export var FeatureToggle = /*#__PURE__*/function () {
  /**
   * Creates a new FeatureToggle instance.
   *
   * @param {string} featureName - [required] String value of the feature in UPPER_SNAKE_CASE format. This value must
   * match the value of the environment property that controls the toggle.
   * @param {boolean} defaultSetting - [optional] Defaults to false. True if the feature should be on by default. Allows the environment
   * variable be unset and still have the feature enabled.
   * @param {function} isEnabledFunction [optional] a reference to a function that will determine if
   * this feature should be enabled. Defaults to the a lookup of the value of the environment property matching the featureName,
   * but could be something more sophisticated, for example if we want to do A/B testing.
   */
  function FeatureToggle(featureName) {
    var defaultSetting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isEnabledFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EnvUtils.getEnvironmentProperty;
    _classCallCheck(this, FeatureToggle);
    if (!featureName) {
      throw new Error("Must supply 'featureName' parameter");
    }
    var re = new RegExp('[A-Z0-9\\_\\"]+$');
    if (featureName.match(re) === null) {
      throw new Error("'featureName' parameter with value '".concat(featureName, "' must be snake case upper, e.g. MY_FEATURE"));
    }
    this.featureName = featureName;
    this.defaultSetting = defaultSetting;
    this.isEnabledFunction = isEnabledFunction;
  }
  _createClass(FeatureToggle, [{
    key: "isEnabled",
    value: function isEnabled() {
      var result = this.isEnabledFunction(this.featureName, this.defaultSetting);
      // Do some error handling here to ensure that a boolan is returned, even if the value is not defined.
      if (result && typeof result !== 'boolean') {
        var _context;
        throw new TypeError(_concatInstanceProperty(_context = "FeatureToggle.isEnabled() function must return a boolean value, but was ".concat(_typeof(result), " '")).call(_context, result, "'"));
      } else if (result === undefined) {
        result = this.defaultSetting;
      }
      return result;
    }
  }, {
    key: "enable",
    value: function enable() {
      process.env[this.featureName] = true;
    }
  }, {
    key: "disable",
    value: function disable() {
      process.env[this.featureName] = false;
    }
  }]);
  return FeatureToggle;
}();

/**
 * Maintain feature toggles here
 * 'featureName' must conform to upper snake case. E.g. MY_FEATURE
 * Each feature toggle should match a value in the .env/.env.development
 * If the base class does not support what you need you can extend it using
 * ES6 subclassing
 */
var defaultOn = true;
var defaultOff = false;
var featureToggles = {
  appeals: new FeatureToggle('REACT_APP_FEATURE_APPEALS_ENABLED', defaultOff),
  lifeEvents: new FeatureToggle('REACT_APP_FEATURE_LIFE_EVENTS_ENABLED', defaultOn),
  verifications: new FeatureToggle('REACT_APP_FEATURE_VERIFICATIONS_ENABLED', defaultOn),
  entitlementCard: new FeatureToggle(UNSAFE_EntitlementCardEnvVarName(), defaultOn)
};
export default featureToggles;